import React, {
  Component,
  PropTypes
} from 'react';
import { addLocaleData, IntlProvider } from 'react-intl';
import en from 'react-intl/locale-data/en';
import fi from 'react-intl/locale-data/fi';
import sv from 'react-intl/locale-data/sv';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { } from '../actions/';
import localeMessages from '../locales';

addLocaleData([...en, ...fi, ...sv]);

class IntlContainer extends Component {
  constructor(props) {

    super(props);
    const { locale } = props;

    this.state = ({
      locale
    });

    let keys = [];
    const translated = {};
    let obj = localeMessages.en;
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (keys.indexOf(key.toLowerCase()) >= 0) {
          console.error(`Duplicate en key : ${key}`);
        }
        keys.push(key.toLowerCase());

        const val = obj[key];
        if (!translated[key]) {
          translated[key] = {};
        }
        translated[key].en = val;
            // use val
      }
    }

    obj = localeMessages.fi;
    keys = [];
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (keys.indexOf(key.toLowerCase()) >= 0) {
          console.error(`Duplicate fi key : ${key}`);
        }
        keys.push(key.toLowerCase());

        const val = obj[key];
        if (!translated[key]) {
          translated[key] = {};
        }
        translated[key].fi = val;
            // use val
      }
    }

    obj = localeMessages.sv;
    keys = [];
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (keys.indexOf(key.toLowerCase()) >= 0) {
          console.error(`Duplicate sv key : ${key}`);
        }
        keys.push(key.toLowerCase());

        const val = obj[key];
        if (!translated[key]) {
          translated[key] = {};
        }
        translated[key].sv = val;
            // use val
      }
    }

    obj = translated;
    keys = [];
    // eslint-disable-next-line guard-for-in
    for (const key in obj) {
      keys.push(key);
    }
    keys.sort();
    keys.forEach(((key) => {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        // console.log(key + "|" + obj[key].en + "|" + obj[key].fi + "|" + obj[key].sv);
        // use val
      }
    }));

  }

  componentWillReceiveProps(nextProps) {
    const { locale } = nextProps;
    this.setState({
      locale
    });
  }

  render() {
    return <IntlProvider locale={this.state.locale} messages={localeMessages[this.state.locale]}>{this.props.children}</IntlProvider>;
  }
}

IntlContainer.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  actions: PropTypes.shape({})
};

function mapStateToProps(state) {
  const props = {
    locale: state.locale
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {};
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(IntlContainer);



// WEBPACK FOOTER //
// ./containers/IntlContainer.js